const user = state => state.user;

export {
  user,
}